// removed by extract-text-webpack-plugin
module.exports = {"header-container":"Header__header-container___3jDqD","header-title-container":"Header__header-title-container___2gK6d","search-icon":"Header__search-icon___3WQLj"};